//React
import { useEffect, useMemo, useState } from "react";
import { NavLink, useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
//Styles&images
//Actions
import {
  deleteStudent,
  getStudents,
  removeStudentfromDeleting,
  removeStudentToUpdating,
} from "../../actions/student";
//Hooks

//Components
import StudentItem from "./StudentItem";
import Modal from "../Modals/Modal";
import LoaderDots from "../generalComponents/LoaderDots";
import AlertPopUp from "../generalComponents/AlertPopUp";
import StudentFormModal from "../Forms/StudentFormModal";
import DangerZoneFormDelete from "../Forms/FormsForModal/DangerZoneFormDelete";
import { useForm } from "../hooks/useForm";
import { images } from "../../constants";
import { getStudentByname } from "../../helper/StudentFilters";

//helpers

const StudentsMain = () => {
  //STATES LOCALES
  const [formValues, handleInputchange, reset] = useForm({
    searchText: "",
  });
  const { searchText } = formValues;

  const [searching, setSearching] = useState(false);
  const [filtered, setFiltered] = useState([]);

  

  const { url } = useRouteMatch();

  //States From Redux
  const state = useSelector((state) => state);
  const { students, ui } = state;
  const { modalOpen } = useSelector((state) => state.ui);

  //Helpers

  const studentBynameFiltered = useMemo(
    () => getStudentByname(students, searchText),
    [searchText, students]
  );


  //Effects
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getStudents());
  }, [dispatch]);

  //HANDLERS
  const handleSearch = (e) => {
    e.preventDefault();

    if (searchText.trim() !== "") {
      setSearching(true);
    }

    if (studentBynameFiltered.length !== 0) {
      setFiltered(studentBynameFiltered);
    }
    if (studentBynameFiltered.length === 0) {
      setFiltered([]);
    }
  };

  const handleClear = () => {
    setFiltered([]);
    setSearching(false);
    reset();
  };

  return (
    <div className="main">
      <div className="main__heading">
        <h1 className="tm-gray">Students</h1>

        <NavLink to={`${url}/section-student`}>
          <button className="btn-primary">+ create</button>
        </NavLink>
      </div>

      <div className="main__search-bar">
        <form onSubmit={handleSearch} className="main__search-bar--form">
          <input
            type="text"
            name="searchText"
            id=""
            value={searchText}
            onChange={handleInputchange}
            placeholder={`Search...`}
            autoComplete="on"
            className="main__search-bar--input tx__sb-gray"
          />
          <button type="submit">
            <img src={images.IconSearch} alt="icon search" />
          </button>
        </form>
        <div className="main__search-bar--bottom">
          {filtered.length !== 0 && (
            <button onClick={handleClear} className="tx__cl-gray">
              Clear All
            </button>
          )}
        </div>
      </div>

      <div className="main__container-items">
        {searching ? (
          <>
            {filtered.length !== 0 ? (
              <ul className="list__wrapper">
                {filtered?.map((student) => (
                  <StudentItem key={student._id} student={student} />
                ))}
              </ul>
            ) : (
              <div className="search-alert">
                <div className="search-alert__item">
                  <AlertPopUp msg={`Search not found`} type={400} />
                  <button className="btn-primary" onClick={handleClear}>
                    Continue
                  </button>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            {students.students.length !== 0 ? (
              <>
                <ul className="list__wrapper">
                  {students.students.map((student) => (
                    <StudentItem key={student._id} student={student} />
                  ))}
                </ul>
                <div className="load-more__container">
                  <p className="link">load more</p>
                </div>
              </>
            ) : (
              <div>
                {ui.loading ? (
                  <LoaderDots />
                ) : (
                  <AlertPopUp msg={"Students not Found"} type={400} />
                )}
              </div>
            )}
          </>
        )}
      </div>
      {modalOpen && students.studentToUpdate && (
        <Modal clean={removeStudentToUpdating}>
          <StudentFormModal />
        </Modal>
      )}

      {modalOpen && students.studentToDelete && (
        <Modal clean={removeStudentfromDeleting}>
          <DangerZoneFormDelete
            element={students.studentName}
            action={deleteStudent}
            remove={removeStudentfromDeleting}
          />
        </Modal>
      )}
    </div>
  );
};

export default StudentsMain;
